import Vue from 'vue'
import Router from 'vue-router'
import adminRouter from '@/views/Admin/adminRouter'
import autenticacaoService from '@/services/autenticacao'
import store from '@/store/index'
import esocialService from '@/services/esocial'

const Dashboard = () => import('@/views/Home/Dashboard')
const Funcionario = () => import('@/views/Home/Funcionario')
const Atestados = () => import('@/views/Home/Atestados')
const Empresas = () => import('@/views/Home/Empresas')
const Indicadores = () => import('@/views/Home/Indicadores')
const RiscoPsicossocial = () => import('@/views/Home/RiscoPsicossocial')
const LinksCadastro = () => import('@/views/Home/LinksCadastro')
const Login = () => import('./views/Autenticacao/Login')
const RedefinirSenha = () => import('./views/Public/RedefinirSenha')
const EnviarTokenEmailForm = () => import('@/views/Public/EnviarTokenEmailForm')
const RedefinirSenhaForm = () => import('@/views/Public/RedefinirSenhaForm')
const SessionExpired = () => import('./views/Autenticacao/SessionExpired')
const NotFound = () => import('./views/Autenticacao/NotFound')
const Home = () => import('./views/Home')
const Agendamento = () => import('@/views/Home/Agendamento')
const Resultado = () => import('@/views/Home/Resultado')
const Ged = () => import('@/views/Home/Ged')
const CertificadoDigital = () => import('@/views/Home/CertificadoDigital')
const SegurancaTrabalho = () => import('@/views/Home/SegurancaTrabalho')
const ClinicaAgendamentos = () => import('@/views/Public/Clinica/ClinicaAgendamentos')
const ESocial = () => import('@/views/Home/ESocial')
// const Beneficios = () => import('@/views/Home/Beneficios')
const ComprarEsocial = () => import('@/views/Home/ComprarEsocial')
const ComprarPsicossocial = () => import('@/views/Home/ComprarPsicossocial')
const ComprarAmbulatorio = () => import('@/views/Home/ComprarAmbulatorio')
const Faturamento = () => import('@/views/Home/Faturamento')
const BemVindo = () => import('@/views/Home/BemVindo')
const SSOAuth = () => import('@/views/Home/SSOAuth')
const ContratoNovoNegocio = () => import('@/views/Home/ContratoNovoNegocio')
const AmbulatorioDigital = () => import('@/views/Public/AmbulatorioDigital')
const RedeAtendimento = () => import('@/views/Home/RedeAtendimento')
const LandingAlimentacao = () => import('@/views/Public/LandingAlimentacao')
const LandingTerceirizacao = () => import('@/views/Public/LandingTerceirizacao')
const IndicacaoParceiroForm = () => import('@/views/Public/IndicacaoParceiroForm')
const Customizacao = () => import('@/views/Home/Customizacao')
const Medico = () => import('@/views/Home/Medico')
const Usuarios = () => import('@/views/Home/Usuarios')
const Riscos = () => import('@/views/Admin/Riscos')
const FaturamentoUnimed = () => import('@/views/Home/FaturamentoUnimed')
const CarteiraDigital = () => import('@/views/Home/CarteiraDigital/CarteiraDigital')
const CarteiraDigitalCreditos = () => import('@/views/Home/CarteiraDigital/CarteiraDigitalCreditos')
const LandingNr1 = () => import('@/views/Public/Nr1/LandingNr1')
const PaginaPrincipal = () => import('@/views/Public/Nr1/PaginaPrincipal')
const SobreNos = () => import('@/views/Public/Nr1/SobreNos')
const Suporte = () => import('@/views/Public/Nr1/Suporte')
const ImportarFuncionarios = () => import('@/views/Home/ImportarFuncionarios')
const ImportarUnidades = () => import('@/views/Home/ImportarUnidades')
const Chamados = () => import('@/views/Admin/Chamados')
const Art = () => import('@/views/Home/Art')
const CarteiraOperacoes = () => import('@/views/Home/CarteiraOperacoes')
const CarteiraClinica = () => import('@/views/Home/CarteiraClinica')
const OnboardingPsicossocial = () => import('@/views/Home/OnboardingPsicossocial')
const OnboardingImportarFuncionarios = () => import('@/views/Home/OnboardingImportarFuncionarios')
const OnboardingImportarUnidades = () => import('@/views/Home/OnboardingImportarUnidades')
const PlanoAcao = () => import('@/views/Home/PlanoAcao')
const FAQ = () => import('@/views/Home/FAQ')
const SelecionarPlanoApoiar = () => import('@/views/Home/SelecionarPlanoApoiar')
const UploadPgr = () => import('@/views/Home/UploadPgr')
const UploadPgrEnvios = () => import('@/views/Home/UploadPgrEnvios')
const Epis = () => import('@/views/Home/Epis')

Vue.use(Router)

const homeRouter = {
  path: '/',
  component: Home,
  children: [
    { path: '', redirect: '/dashboard' },
    adminRouter,
    { path: 'dashboard', name: 'dashboard', component: Dashboard },
    { path: 'empresa', name: 'empresa', component: Empresas },
    { path: 'funcionario', name: 'funcionario', component: Funcionario },
    { path: 'atestados', name: 'atestados', component: Atestados },
    { path: 'indicadores', name: 'indicadores', component: Indicadores },
    { path: 'riscos-psicossociais', name: 'riscos-psicossociais', component: RiscoPsicossocial },
    {
      path: 'riscos-psicossociais/meus-envios-pgr',
      name: 'upload-pgr-envios',
      component: UploadPgrEnvios,
      meta: { requiredPermissions: ['enableUploadPgr'] },
    },
    {
      path: 'riscos-psicossociais/enviar-pgr/envio/:envioEncriptado',
      name: 'upload-pgr-envio',
      component: UploadPgr,
      props: true,
      meta: { requiredPermissions: ['enableUploadPgr'] },
    },
    {
      path: 'riscos-psicossociais/enviar-pgr',
      name: 'upload-pgr',
      component: UploadPgr,
      meta: { requiredPermissions: ['enableUploadPgr'] },
    },
    { path: 'links-cadastro', name: 'links-cadastro', component: LinksCadastro },
    {
      path: 'agendamento',
      name: 'agendamento',
      component: Agendamento,
      meta: { requiredPermissions: ['enableFluxoOcupacional'] },
    },
    { path: 'chamados', name: 'chamados-home', component: Chamados, meta: { requiredPermissions: ['enableChamados'] } },
    {
      path: 'resultados',
      name: 'resultados',
      component: Resultado,
      meta: { requiredPermissions: ['enableFluxoOcupacional'] },
    },
    { path: 'ged', name: 'ged', component: Ged },
    {
      path: 'certificado-digital',
      name: 'certificado-digital',
      component: CertificadoDigital,
      meta: { requiresEsocial: true },
    },
    { path: 'seguranca-trabalho', name: 'seguranca-trabalho', component: SegurancaTrabalho },
    { path: 'epis', name: 'epis', component: Epis, meta: { requiredPermissions: ['enableEpis'] } },
    { path: 'entregas-epi', redirect: { name: 'epis', query: { tab: 'entregas' } } },
    { path: 'rede-atendimento', name: 'rede-atendimento', component: RedeAtendimento },
    { path: 'esocial', name: 'esocial', component: ESocial, meta: { requiresEsocial: true } },
    // { path: 'beneficios', name: 'beneficios', component: Beneficios },
    { path: 'comprar-esocial', name: 'comprar-esocial', component: ComprarEsocial },
    { path: 'comprar-psicossocial', name: 'comprar-psicossocial', component: ComprarPsicossocial },
    { path: 'comprar-ambulatorio', name: 'comprar-ambulatorio', component: ComprarAmbulatorio },
    { path: 'faturamento/:empresa', name: 'faturamento', component: Faturamento, props: true },
    { path: 'bem-vindo', name: 'bem-vindo', component: BemVindo },
    { path: 'customizacao', name: 'customizacao', component: Customizacao },
    { path: 'medicos', name: 'medicos', component: Medico },
    { path: 'usuarios', name: 'usuarios', component: Usuarios },
    { path: 'riscos', name: 'riscos', component: Riscos },
    { path: 'financeiro/faturamento', name: 'faturamento-unimed', component: FaturamentoUnimed },
    { path: 'financeiro/carteira-digital', name: 'carteira-digital', component: CarteiraDigital },
    { path: 'financeiro/art', name: 'art', component: Art, meta: { requiredWorkspace: 'Unimed' } },
    { path: 'financeiro/carteira-operacoes', name: 'carteira-operacoes', component: CarteiraOperacoes },
    { path: 'financeiro/carteira-clinica', name: 'carteira-clinica', component: CarteiraClinica },
    {
      path: 'financeiro/carteira-digital/comprar-creditos',
      name: 'carteira-digital-comprar-creditos',
      component: CarteiraDigitalCreditos,
    },
    { path: 'importar-funcionarios', name: 'importar-funcionarios', component: ImportarFuncionarios },
    {
      path: 'onboarding-importar-funcionarios',
      name: 'onboarding-importar-funcionarios',
      component: OnboardingImportarFuncionarios,
    },
    { path: 'importar-unidades', name: 'importar-unidades', component: ImportarUnidades },
    {
      path: 'onboarding-importar-unidades',
      name: 'onboarding-importar-unidades',
      component: OnboardingImportarUnidades,
    },
    { path: 'onboarding-psicossocial', name: 'onboarding-psicossocial', component: OnboardingPsicossocial },
    { path: 'faq-psicossocial', name: 'faq-psicossocial', component: FAQ },
    {
      path: 'selecionar-plano',
      name: 'selecionar-plano',
      component: SelecionarPlanoApoiar,
      meta: { disableHeader: true, disableNavigation: true },
    },
  ],
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    homeRouter,
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/recuperar-senha',
      component: RedefinirSenha,
      meta: { public: true },
      children: [
        {
          path: '',
          name: 'recuperarSenha',
          component: EnviarTokenEmailForm,
          meta: { public: true },
        },
        {
          path: 'redefinir-senha',
          name: 'redefinirSenha',
          component: RedefinirSenhaForm,
          meta: { public: true },
        },
      ],
    },
    {
      path: '/erro/sessaoExpirada',
      name: 'sessionExpired',
      component: SessionExpired,
      meta: { public: true },
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound,
      meta: { public: true },
    },
    {
      path: '/clinica/:token/agendamentos',
      name: 'clinica',
      component: ClinicaAgendamentos,
      props: true,
      meta: { public: true },
    },
    {
      path: '/sso-auth/:token',
      name: 'sso',
      component: SSOAuth,
      meta: {
        public: true,
      },
    },
    {
      path: '/contrato/novo-negocio/:token',
      name: 'contrato-novo-negocio',
      component: ContratoNovoNegocio,
      meta: {
        public: true,
      },
    },
    {
      path: '/ambulatorio-digital',
      name: 'ambulatorio-digital',
      component: AmbulatorioDigital,
      meta: {
        public: true,
      },
    },
    {
      path: '/formulario-indicacao',
      name: 'formulario-indicacao',
      component: IndicacaoParceiroForm,
      meta: {
        public: true,
      },
    },
    {
      path: '/setor-alimentacao',
      name: 'setor-alimentacao',
      component: LandingAlimentacao,
      meta: {
        public: true,
      },
    },
    {
      path: '/setor-terceirizacao',
      name: 'setor-terceirizacao',
      component: LandingTerceirizacao,
      meta: {
        public: true,
      },
    },
    {
      path: '/nr1',
      component: LandingNr1,
      meta: {
        public: true,
      },
      children: [
        {
          path: '',
          name: 'pagina-principal',
          component: PaginaPrincipal,
          meta: { public: true },
        },
        {
          path: 'sobre',
          name: 'sobre',
          component: SobreNos,
          meta: { public: true },
        },
        {
          path: 'suporte',
          name: 'suporte',
          component: Suporte,
          meta: { public: true },
        },
      ],
    },
    {
      path: '/psicossocial/:idMapeamento/plano-acao',
      name: 'plano-acao',
      component: PlanoAcao,
      props: true,
      meta: { public: true },
    },
  ],
})

function getHaveToChoosePlan() {
  return store.getters['autenticacao/haveToChoosePlan'] || false
}

function getIsApoiar() {
  return store.getters['autenticacao/isApoiar'] || false
}

function isPublicPage(to) {
  return to.matched.some(m => m.meta.public)
}

function isPrivatePage(to, routes = homeRouter.children) {
  if (to.path.includes('/admin')) return true

  return routes.some(route => {
    if (route.name === to.name) return true
    if (route.children) return isPrivatePage(to, route.children)
    return false
  })
}

function isLoginPage(to) {
  return to.name === 'login'
}

function isHomePage(to) {
  return to.path === '/'
}

function isFromAnyPrivatePage(from) {
  return isPrivatePage(from)
}

function pageAllowed(to) {
  const tipoUsuario = store.getters['autenticacao/tipoUsuario']
  const blockUsersCreation = store.getters['autenticacao/blockUsersCreation']
  const parceiro = store.getters['autenticacao/parceiro']
  const idParceiro = store.getters['autenticacao/idParceiro']
  const enableAdministracao = store.getters['autenticacao/enableAdministracao']

  if (to.path.includes('/admin')) {
    if (tipoUsuario === 1) {
      return enableAdministracao && !parceiro && !idParceiro
    }
    if (tipoUsuario === 3) {
      return false
    }
    if (blockUsersCreation || tipoUsuario === 2) {
      return false
    }
    return true
  }

  return true
}

function hasPermission(requiredPermissions) {
  const permissions = []

  for (const permission of requiredPermissions) {
    permissions.push(store.getters[`autenticacao/${permission}`] || false)
  }
  return permissions.every(permission => permission)
}

function hasWorkspace(requiredWorkspace) {
  return store.getters['autenticacao/workspace'] === requiredWorkspace
}

router.beforeEach(async (to, from, next) => {
  const haveToChoosePlan = getHaveToChoosePlan()
  const isApoiar = getIsApoiar()

  if (to.matched.some(record => record.meta && record.meta.requiresEsocial)) {
    try {
      await esocialService.verificarAcesso()
    } catch (error) {
      if (error.response && error.response.status === 403) {
        new Vue({ store }).showErrorOnSnackbar(error.response.data.message)

        next(from.path !== '/' ? from.path : { name: 'dashboard' })
        return
      }
    }
  }

  if (isPrivatePage(to)) {
    if (autenticacaoService.isAuthenticated() && pageAllowed(to)) {
      if (haveToChoosePlan && isApoiar && to.name !== 'selecionar-plano') {
        next({ name: 'selecionar-plano' })
        return
      }

      if (to.meta.requiredWorkspace && !hasWorkspace(to.meta.requiredWorkspace)) {
        next({ name: 'notFound' })
        return
      }

      if (to.meta.requiredPermissions && !hasPermission(to.meta.requiredPermissions)) {
        next({ name: 'notFound' })
        return
      }
      next()
    } else if (autenticacaoService.isAuthenticated()) {
      next({ name: 'dashboard' })
    } else if (isFromAnyPrivatePage(from)) {
      next({ name: 'sessionExpired' })
    } else if (to.query.redirectTo) {
      next({ name: 'login', query: { redirectTo: to.query.redirectTo } })
    } else {
      next({ name: 'login' })
    }
  } else if (isPublicPage(to)) {
    next()
  } else if (isHomePage(to)) {
    if (!autenticacaoService.isAuthenticated()) {
      next({ name: 'login' })
    } else if (haveToChoosePlan && isApoiar) {
      next({ name: 'selecionar-plano' })
    } else {
      next({ name: 'dashboard' })
    }
  } else if (isLoginPage(to)) {
    if (!autenticacaoService.isAuthenticated()) {
      next()
    } else if (haveToChoosePlan && isApoiar) {
      next({ name: 'selecionar-plano' })
    } else {
      next({ name: 'dashboard' })
    }
  } else {
    next({ name: 'notFound' })
  }
})

export default router
